<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-card
          body-class="p-2 d-flex flex-column flex-sm-column flex-md-row justify-content-between"
          class="shadow-sm"
          border-variant="white"
        >
          <h4 class="m-0 font-weight-bold text-center text-md-left">
            <i class="fas fa-star"></i> แทง{{ lottoInfo.lottoDesc }}
          </h4>
          <div v-if="lottoInfo.isBetAvailable">
            <b-badge variant="dark" class="mr-2">ประจำวันที่</b-badge
            >{{ formatDate(lottoInfo.lottoDate, "DD MMM YYYY") }}
          </div>
          <div v-if="lottoInfo.isBetAvailable == false">
            <font color="red"
              >{{ lottoInfo.lottoDesc }}ยังไม่เปิดกรุณารอรอบต่อไป</font
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-card body-class="p-2" class="shadow-sm" border-variant="white">
          <b-row>
            <b-col cols="12" md="6">
              <div class="group__keyboard">
                <div class="num-pad box__show-number">
                  <h4 class="text-center">ระบุตัวเลข 4 หลัก</h4>
                  <b-row>
                    <b-col
                      class="d-flex label-number lists justify-content-center"
                    >
                      <input
                        class="form-control number code-input text-center align-self-center bg-white"
                        maxlength="1"
                        v-model="number[0]"
                        @keypress="isNumber"
                        @keyup="goNext($event.target)"
                        readonly
                      />
                      <input
                        class="form-control number code-input text-center align-self-center bg-white"
                        maxlength="1"
                        v-model="number[1]"
                        @keypress="isNumber"
                        @keyup="goNext($event.target)"
                        readonly
                      />
                      <input
                        class="form-control number code-input text-center align-self-center bg-white"
                        maxlength="1"
                        v-model="number[2]"
                        @keypress="isNumber"
                        @keyup="goNext($event.target)"
                        readonly
                      />
                      <input
                        class="form-control number code-input text-center align-self-center bg-white"
                        maxlength="1"
                        v-model="number[3]"
                        @keypress="isNumber"
                        @keyup="goNext($event.target)"
                        readonly
                      />
                    </b-col>
                  </b-row>
                  <!-- <div class="label-number lists d-flex justify-content-center">
                    <label class="number"></label>
                    <label class="number"></label>
                    <label class="number"></label>
                    <label class="number"></label>
                  </div> -->

                  <div class="key-pad box__keyboard">
                    <div class="row p-2">
                      <div class="col-9">
                        <b-row class="numpad">
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="1"
                              @click="numpadClick('1')"
                            >
                              1
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="2"
                              @click="numpadClick('2')"
                            >
                              2
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="3"
                              @click="numpadClick('3')"
                            >
                              3
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="4"
                              @click="numpadClick('4')"
                            >
                              4
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="5"
                              @click="numpadClick('5')"
                            >
                              5
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="6"
                              @click="numpadClick('6')"
                            >
                              6
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="7"
                              @click="numpadClick('7')"
                            >
                              7
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="8"
                              @click="numpadClick('8')"
                            >
                              8
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="9"
                              @click="numpadClick('9')"
                            >
                              9
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button class="btn btn-blank" disabled></button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button
                              class="btn btn-outline-primary btn-block"
                              data-id="0"
                              @click="numpadClick('0')"
                            >
                              0
                            </button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <button class="btn btn-blank" disabled></button>
                          </b-col>
                          <b-col cols="4" class="p-1">
                            <!-- <button class="btn btn-blank" disabled></button> -->
                          </b-col>
                        </b-row>
                      </div>
                      <b-col cols="3">
                        <b-row class="numpad">
                          <b-col cols="12" class="p-1">
                            <button
                              class="btn btn-danger btn-block"
                              data-id="delete"
                              @click="
                                number = number.substring(0, number.length - 1)
                              "
                            >
                              <i class="fas fa-backspace"></i>
                            </button>
                          </b-col>
                          <b-col cols="12" class="p-1">
                            <button
                              class="btn btn-secondary btn-block btn-cancel warning btn-cancle-last-add-num"
                              @click="numbers.splice(-1, 1)"
                            >
                              <span class="small">ยกเลิกล่าสุด</span>
                            </button>
                          </b-col>
                          <b-col cols="12" class="p-1">
                            <button
                              class="btn btn-dark btn-block btn-reset btn-reset-jp"
                              @click="numbers = []"
                            >
                              <span class="small">ล้างข้อมูล</span>
                            </button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12" class="py-1 px-3">
                  <div class="w-100 rounded border p-2">
                    <i class="fas fa-clipboard-list"></i> รายการแทง
                    <div
                      class="w-100 border border-secondary border-bottom-0 m-1"
                    ></div>
                    <div class="box-list-jackpot">
                      <b-row class="number-item">
                        <b-col>ชุดเลข</b-col>
                        <b-col class="text-right">จำนวนชุด</b-col>
                      </b-row>
                      <b-row
                        class="number-item"
                        v-for="(item, index) in numbers"
                        v-bind:key="index"
                      >
                        <b-col cols="6" class="number font-mitr">
                          {{ item.number }}
                        </b-col>
                        <b-col cols="6" class="amount">
                          <b-input-group append="ชุด">
                            <b-form-input
                              class="text-right"
                              v-model="item.amount"
                              type="number"
                              min="1"
                            ></b-form-input>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-row flex-sm-row flex-md-row-reverse justify-content-between justify-content-sm-between justify-content-md-end"
                  >
                    <div class="p-1" v-if="lottoInfo.isBetAvailable">
                      <span class="badge badge-dark font-weight-light"
                        >ประจำวันที่</span
                      >
                      {{ formatDate(lottoInfo.lottoDate, "DD MMM YYYY") }}
                    </div>
                    <div class="p-1" v-if="lottoInfo.isBetAvailable == false">
                      <font color="red"
                        >{{
                          lottoInfo.lottoDesc
                        }}ยังไม่เปิดกรุณารอรอบต่อไป</font
                      >
                    </div>
                  </div>
                </b-col>
                <b-col cols="6" class="py-1 pr-1 pl-3">
                  <div class="w-100 rounded table-primary p-1 text-center">
                    ใช้ Credit ทั้งหมด
                    <h4 class="mb-0 total_price font-mitr font-weight-bold">
                      {{ totalAmount }}
                    </h4>
                  </div>
                </b-col>
                <b-col cols="6" class="py-1 pr-3 pl-1">
                  <div class="w-100 rounded table-secondary p-1 text-center">
                    Credit คงเหลือ
                    <h4 class="m0 my-reward font-mitr  font-weight-bold">
                      {{ getCashAmount }}
                      <small>
                        <i class="fas fa-parking"></i>
                      </small>
                    </h4>
                  </div>
                </b-col>
                <b-col cols="12" class="py-1 px-3">
                  <button
                    class="btn btn-success btn-block triggerSendjackpot"
                    :disabled="
                      numbers.length == 0 || lottoInfo.isBetAvailable == false
                        ? true
                        : false
                    "
                    @click="confirmTang"
                  >
                    ยืนยันการแทง
                  </button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-modal
            id="modal-center"
            body-class="text-center py-5"
            centered
            hide-header
            hide-footer
          >
            <i class="fas fa-exclamation fa-2x text-warning"></i>
            <h4 class="font-weight-bold mt-3">
              คุณต้องการแทง: {{ lottoInfo.lottoDesc }}
            </h4>
            <div
              class="py-1"
              v-for="(item, index) in numbers"
              v-bind:key="index"
            >
              {{ item.number }} จำนวน {{ item.amount }} ชุด
            </div>
            <div class="font-weight-bold mt-2">
              รวมเป็นเงิน {{ totalAmount }} บาท
            </div>
            <div class="mt-3">
              <b-btn variant="primary" class="mx-2 px-4" @click="submitTang"
                >ยืนยันการแทง</b-btn
              >
              <b-btn
                variant="secondary"
                class="mx-2 px-4"
                @click="$bvModal.hide('modal-center')"
                >ปิด</b-btn
              >
            </div>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "Tang",
  props: ["lottoType"],
  data() {
    return {
      number: "",
      typeActive: "number",
      numbers: [],
      unitPrice: 120,
      lottoInfo: [],
      lottos: [],
      lottoName: null,
      betSlot: [],
    };
  },
  mounted() {
    console.log(this.lottoType);
    this.getLottoInfo();
    // console.log('get lotto type', this.getLottoType);
    window.addEventListener('keyup', this.pressNumber);
  },
  methods: {
    ...mapActions({
      setCashAmount: "setCashAmount",
      setRewardAmount: "setRewardAmount",
    }),
    pressNumber(e) {
      if (
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105)
      ) {
        this.numpadClick(e.key)
      }
      else if (e.keyCode === 8) {
        this.number = this.number.substring(0, this.number.length - 1);
      }
      else {
        e.preventDefault();
      }
    },
    refreshAmount() {
      axios
        .post(
          this.getApiUrl + "/customer/getcurrentfinance",
          {
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          console.log("refreshAmount",response);
          if (response.data.statusCode == 200) {
            this.setCashAmount(response.data.data.cashAmount);
            this.setRewardAmount(response.data.data.jackpotCredit);
          }
        });
    },
    getLottoAvailable() {
      axios
        .post(
          this.getApiUrl + "/pingpong/lottotypeavailable",
          {
            username: this.getUsername,
            lottoType: this.lottoType,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          this.lottos = response.data.data;
          console.log("Get lottos", response);
        });
    },
    getLottoInfo() {
      axios
        .post(
          this.getApiUrl + "/lottoset/available",
          {
            username: this.getUsername,
            lottoType: parseInt(this.lottoType),
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          if (parseInt(this.lottoType) == 29) {
            this.lottoInfo = response.data.data;
          } else {
            this.lottoInfo = response.data.data[0];
          }
          console.log("GetLottoInfo", this.lottoInfo);
          // this.lottoName = this.getLottoType[
          //   this.getLottoType.map(e => e.lottoType).indexOf(parseInt(this.lottoType))
          // ].lottoName;
          // console.log("lotto name", this.lottoName);
        });
    },
    numpadClick(number) {
      if (this.number.length === null || this.number.length < 4) {
        this.number = this.number + number;
      }
      if (this.number.length == 4) {
        setTimeout(() => {
          this.addNumber();
        }, 125);
      }
      console.log(this.number);
    },
    addNumber() {
      this.numbers.push({ number: this.number, amount: 1 });
      this.number = "";
      console.log(this.numbers);
    },
    isNumber(val) {
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },
    goNext(elem) {
      if (elem.value.length == 1) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
          )
          .focus();
      } else if (elem.value.length == 0) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex - 1 : 0
          )
          .focus();
      }
    },
    confirmTang() {
      const betValue = this.numbers.length * this.unitPrice;
      if (betValue > this.getCashAmount) {
        this.$bvToast.toast("จำนวนเงินของคุณไม่พอ", {
          title: "แทงหวยชุด",
          variant: "danger",
          solid: true,
          appendToast: true,
        });
      } else {
        this.$bvModal.show("modal-center");
      }
    },
    submitTang() {
      axios
        .post(
          this.getApiUrl + "/pingpong/bet",
          {
            lottoType: this.lottoType,
            ReferID: this.lottoInfo.lottoResultId,
            betSlot: this.betSlot,
            username: this.getUsername,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername,
            },
          }
        )
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.numbers = [];
            this.$bvModal.hide("modal-center");
            this.$bvToast.toast("ส่งข้อมูลการแทงสำเร็จแล้ว", {
              title: "แทงหวยชุด",
              variant: "success",
              solid: true,
              appendToast: true,
            });
            this.refreshAmount();
          } else {
            this.$bvModal.hide("modal-center");
            this.$bvToast.toast("ส่งข้อมูลการแทงผิดพลาด", {
              title: "แทงหวยชุด",
              variant: "danger",
              solid: true,
              appendToast: true,
            });
          }
          console.log(response);
        });
    },
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl"
    }),
    totalAmount() {
      let amount = 0;
      this.betSlot = [];
      this.numbers.forEach((value) => {
        amount = amount + value.amount * this.unitPrice;
        this.betSlot.push({
          betNumber: value.number,
          betNumberType: 1,
          betPrice: value.amount * this.unitPrice,
        });
      });
      console.log(amount);
      return amount;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

.code-input {
  border-color: #bd841b !important;
  width: 50px;
  padding: 0;
  margin: 10px 10px;
  font-size: 30px;
  line-height: 50px;
  height: 50px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

.number-item {
  .number {
    font-weight: bold;
    font-family: "Mitr", sans-serif;
    font-size: 2rem;
    letter-spacing: 10px;
  }
}

.goldenrod {
  background-color: goldenrod;
  font-weight: normal;
  color: #fff;
}

.text-gold {
  color: rgb(189, 132, 41) !important;
}

.gold-box {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07 !important;
  text-shadow: black 1px 1px 3px;
}

.bordered {
  border: 1px solid #007bff !important;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }
}

label.number {
  display: inline-block;
  width: 50px;
  height: 50px;
  margin: 0px 5px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.2);
  border: solid 1px #000000;
  color: #976f02;
  border-radius: 2px;
  background-color: rgba(229, 229, 229, 0.2);
  border: solid 1px #976f02;
  position: relative;
  vertical-align: middle;
}

.num-pad h4 {
  font-family: inherit;
  color: #aa7114;
}

.key-pad {
  .col-4 {
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 4px;

    .btn-blank {
      color: #fff;
      background-color: #ccc;
      background-image: none;
      border-color: #bbb;
      width: 100%;
      height: 100%;
    }

    .btn {
      font-size: 20px !important;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .col-12 {
    .btn {
      font-size: 20px !important;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}

.btn-danger {
  display: inline-block;
  outline: none;
  font-family: inherit;
  /* font-size: 80%; */
  box-sizing: border-box;
  border: none;
  border-radius: 0.3em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 5px;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5) !important;
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.box-list-jackpot {
  width: 100%;
  min-height: 140px;
  overflow-x: hidden;
}
</style>
